
import { createReducer, on } from '@ngrx/store';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { defaultEntityState } from '@core/state/entities/entity';
import {
  mergeEntityState, removeEntities, removeEntitiesByFilter,
} from '@core/state/entities/entity.helpers';
import { entityKey } from '@core/state/entities/entity-name-map';
import { IRiskOfBiasJob } from '@core/state/entities/risk-of-bias-job/risk-of-bias-job.entity';
export const riskOfBiasJobReducer = createReducer(
  defaultEntityState<IRiskOfBiasJob>(),

  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.projectUpdated,
    (state, props) =>
      mergeEntityState(
        entityKey.riskOfBiasJobs,
        state,
        props,
        (bsu) => bsu.projectId === props.projectId
      )
  ),
  on(projectDetailActions.registered, (state, props) =>
    mergeEntityState(entityKey.riskOfBiasJobs, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (projChild) => projChild.projectId === props.projectId
    )
  ),
  // on(
  //   projectDetailActions.deleteBulkStudyUpdateJob,
  //   projectDetailActions.bulkStudyUpdateJobCancelled,
  //   (state, props) => removeEntities(entityKey.riskOfBiasJobs, state, props)
  // )

);
